import { render, staticRenderFns } from "./OrderFormStep5.module.vue?vue&type=template&id=eb5ddf0a&scoped=true&"
import script from "./OrderFormStep5.module.vue?vue&type=script&lang=js&"
export * from "./OrderFormStep5.module.vue?vue&type=script&lang=js&"
import style0 from "./OrderFormStep5.module.vue?vue&type=style&index=0&id=eb5ddf0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb5ddf0a",
  null
  
)

export default component.exports